import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';

export default class FormToggleComponent extends Component {
    static displayName = 'FormToggleComponent';
    static propTypes = {
        label: PropTypes.string,
        hideLabel: PropTypes.string,
        additionalClassNames: PropTypes.string
    };
    static defaultProps = {
        label: '+'
    };

    constructor(props) {
        super(props);
        this.state = {isVisible: !!props.isVisible};
    }

    handleToggleClick = () => {
        this.setState({isVisible: !this.state.isVisible});
    };

    render() {
        const {isVisible} = this.state;
        const {className} = this.props;
        const label = isVisible ? this.props.hideLabel : this.props.label;
        const childrenStyle = {
            visibility: isVisible ? 'visible' : 'hidden',
            height: isVisible ? 'auto' : 0
        };

        const toggleClasses = classNames('toggle-component', className);

        return (
            <div className={toggleClasses}>
                {label && (
                    <button className="btn btn-default" onClick={this.handleToggleClick}>
                        {label}
                    </button>
                )}
                <div style={childrenStyle}>{this.props.children}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_toggle_component.js